import React from 'react'
import { PreviewArticleCard } from '../cards/PreviewArticleCard'
import { articleType } from '../article'

export const RecommendedArticlesSection = ({
  nr,
  recommendedArticles,
}: {
  nr: number
  recommendedArticles: articleType[]
}) => {
  return (
    <div className='flex flex-col items-center xl:items-start gap-8 max-w-[1280px]'>
      <h3 className='text-2xl text-[#001A3D] font-bold'>
        Recommended blog articles
      </h3>

      <div className='flex justify-center xl:justify-start flex-wrap gap-6'>
        {recommendedArticles.slice(0, nr).map((article, idx) => (
          <PreviewArticleCard
            key={article.title + idx}
            {...article}
            route={`/articles/${article.id}`}
          />
        ))}
      </div>
    </div>
  )
}
